<template>
    <div class="unitMPage">
        <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
            @resetFn="resetFn" @searchFn="searchFn" @confirmFn="searchFn" @AddFn="AddFn" @rowDel="rowDel($event, false)" />
        <div class="componentPage">
            <v-table :tableData="tableData" :loading="loading" @rowEdit="rowEdit" @selectRow="selectRow"
                @rowDel="rowDel($event, true)" />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <Modal :visible.sync="isShow" width="600px" :title="title">
            <v-form ref="vForm" />
            <div slot="footer">
                <el-button type="primary" @click="isShow = false">{{ $t('public.btn_close') }}</el-button>
                <el-button type="primary" @click="handleClick">{{ $t('buttonTitle.Save') }}</el-button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { probeUnitPage, probeUnitAdd, probeUnitEdit, probeUnitDelete } from '@/api/modules/unit.js';
import table from './components/Table.vue';
import form from './components/Form.vue';
export default {
    components: {
        'v-table': table,
        'v-form': form
    },
    data() {
        return {
            SearchForm: {
                name: null,
                title: null,
                iDisplayStart: 0,
                iDisplayLength: 15
            },
            formContent: [
                {
                    id: 1,
                    text: 'probeunit.unit',
                    type: 'input',
                    paramsName: 'name',
                    isChooze: true
                },
                {
                    id: 2,
                    text: 'probeunit.unitMark',
                    type: 'input',
                    paramsName: 'title',
                    isChooze: false
                }
            ],
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: [],
                    text: 'buttonTitle.Add1',
                    method: 'AddFn'
                },
                {
                    id: 2,
                    text: 'buttonTitle.Delete',
                    icon: '',
                    method: 'rowDel',
                    vHas: []
                }
            ],
            tableData: [],
            loading: false,
            total: 0,
            isShow: false,
            title: '',
            selectData: []
        };
    },
    created() {
        this.getListFn();
    },
    methods: {
        getListFn() {
            probeUnitPage(this.SearchForm).then(({ result, pageInfo }) => {
                this.tableData = result;
                this.total = pageInfo.total;
            });
        },
        searchFn() {
            this.getListFn();
        },
        resetFn() {
            this.SearchForm = {
                name: null,
                title: null,
                iDisplayStart: 0,
                iDisplayLength: 15
            };
            this.getListFn();
        },
        AddFn() {
            this.isShow = true;
            this.title = this.$t('buttonTitle.Add') + this.$t('probeunit.unitMeasurement');

            this.$nextTick(() => {
                this.$refs.vForm.clearValidate();
                delete this.$refs.vForm.dioForm.id;
            });
        },
        rowEdit(row) {
            this.$nextTick(() => {
                this.$refs.vForm.clearValidate();
            });
            this.isShow = true;

            this.title = this.$t('buttonTitle.Edit') + ` [${row.title}] ` + this.$t('probeunit.unitMeasurement');
            const { name, title, code, desc, id } = row;

            this.$nextTick(() => {
                this.$refs.vForm.dioForm = {
                    name,
                    title,
                    code,
                    desc,
                    id
                };
            });
        },
        selectRow(row) {
            this.selectData = row.map(item => item.id);
        },
        async handleClick() {
            const flag = await this.$refs.vForm.justify();
            if (!flag) return;
            let query = this.$refs.vForm.dioForm;
            let httpUrl = null;
            if (query.id) {
                httpUrl = probeUnitEdit;
            } else {
                httpUrl = probeUnitAdd;
            }

            httpUrl(query).then(async ({ result, state }) => {
                if (result === 200) {
                    await this.$resultHandle(state);
                    this.getListFn();
                    this.isShow = false;
                } else if (result === 408) {
                    this.$message.error($t('integration.uom_already_exists'));
                } else if (result === 409) {
                    this.$message.error($t('integration.unit_tag_already_exists'));
                } else if (result === 410) {
                    this.$message.error($t('integration.unit_number_already_exists'));
                } else {
                    this.$message.error(state.msg);
                }
            });
        },
        rowDel(query, bool) {
            console.log(this.selectData, query, bool);
            /** 单条 */
            let ids = null;
            if (bool) {
                ids = query.id;
            } else {
                if (this.selectData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
                ids = this.selectData.join(',');
            }
            this.TODOTIPDEL(ids);
        },
        TODOTIPDEL(ids) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    probeUnitDelete({ ids: ids }).then(({ state }) => {
                        if (state.code === 200) {
                            this.getListFn();
                            this.$message.success(this.$t('public.tip_del_succ').toString());
                        }
                    });
                })
                .catch(() => { });
        },
        /**
         *
         * @param {*消息提示国际化} msg
         */
        tip(msg) {
            this.isShow = false;
            this.getListFn();
            this.$message.success(msg);
        }
    }
};
</script>

<style lang="scss" scoped>
.unitMPage {
    height: 100%;
    padding: 15px;
    padding-bottom: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.componentPage {
    flex: 1;

    .pagination {
        padding-top: 0;
        padding-right: 15px !important;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}
</style>
